import request from '@/router/axios'

const baseUrl = '/api/produce/emergency-task'

export const getTodoList = (data) => {
  return request({
    url: `${baseUrl}/approval-page`,
    method: 'post',
    data
  })
}

export const getDoneList = (data) => {
  return request({
    url: `${baseUrl}/approval-done-page`,
    method: 'post',
    data
  })
}

export const getDetail = (id) => {
  return request({
    url: `${baseUrl}/select/id`,
    method: 'get',
    params: { id }
  })
}

export const batchAssign = (eventId) => {
  return request({
    url: `${baseUrl}/batchAssign`,
    method: 'get',
    params: { eventId }
  })
}

export const assignGroup = (params) => {
  return request({
    url: `${baseUrl}/assignGroup`,
    method: 'get',
    params
  })
}

export const assignExpert = (eventId) => {
  return request({
    url: `${baseUrl}/assignExpert`,
    method: 'get',
    params: { eventId }
  })
}

export const audit = (data) => {
  return request({
    url: `${baseUrl}/audit`,
    method: 'post',
    data
  })
}
